import React from "react";

export const PipelineModal = ({
  pipelineModal,
  onClose,
  pipelineSort,
  setPipelineSort,
  showInDollars,
  modoCombinado,
  clientes,
  moneda,
  localString,
  tipoCambioActual,
  pais,
  styles,
}) => {
  if (!pipelineModal.open) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h5>{pipelineModal.title}</h5>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ fontSize: "0.85rem", margin: 0 }}>Ordenar:</label>
            <select
              value={pipelineSort}
              onChange={(e) => setPipelineSort(e.target.value)}
              style={{ padding: "4px 8px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
            >
              <option value="importe">Mayor importe</option>
              <option value="cliente">Cliente (A-Z)</option>
              {modoCombinado && <option value="pais">País</option>}
            </select>
            <button onClick={onClose}>&times;</button>
          </div>
        </div>
        <div className={styles.modalBody}>
          {pipelineModal.items.length === 0 ? (
            <p className={styles.noData}>No hay oportunidades en pipeline para este período</p>
          ) : (
            <>
              <div style={{ overflowX: "auto" }}>
                <table className={styles.modalTable} style={{ width: "100%", tableLayout: "fixed" }}>
                  <thead>
                    <tr>
                      {modoCombinado && <th style={{ width: "15%" }}>País</th>}
                      <th style={{ width: modoCombinado ? "35%" : "50%" }}>Cliente</th>
                      <th style={{ width: modoCombinado ? "30%" : "30%" }}>Importe</th>
                      <th style={{ width: "20%" }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...pipelineModal.items]
                      .sort((a, b) => {
                        if (pipelineSort === "importe") {
                          return (parseFloat(b.importe) || 0) - (parseFloat(a.importe) || 0);
                        } else if (pipelineSort === "cliente") {
                          const cA = clientes[a.client_id];
                          const clienteA = cA
                            ? cA.producto && cA.producto !== cA.empresa
                              ? `${cA.empresa} | ${cA.producto}`
                              : cA.empresa
                            : a.cliente || "";
                          const cB = clientes[b.client_id];
                          const clienteB = cB
                            ? cB.producto && cB.producto !== cB.empresa
                              ? `${cB.empresa} | ${cB.producto}`
                              : cB.empresa
                            : b.cliente || "";
                          return clienteA.localeCompare(clienteB);
                        } else if (pipelineSort === "pais") {
                          return (a.paisOrigen || "").localeCompare(b.paisOrigen || "");
                        }
                        return 0;
                      })
                      .map((op, idx) => {
                        const importe = parseFloat(op.importe) || 0;
                        const esChile = op.paisOrigen === "Chile";
                        const monedaLocal = esChile ? "$ " : "S/ ";
                        const localeLocal = esChile ? "es-CL" : "es-PE";

                        // Moneda original por fila
                        let montoFila;
                        if (op.moneda_dolar) {
                          montoFila = `US$ ${importe.toLocaleString(localeLocal, { maximumFractionDigits: 0 })}`;
                        } else if (showInDollars || modoCombinado) {
                          const rateLocal = esChile ? tipoCambioActual : 3.75;
                          montoFila = `US$ ${(importe / rateLocal).toLocaleString(localeLocal, { maximumFractionDigits: 0 })}`;
                        } else {
                          montoFila = `${monedaLocal}${importe.toLocaleString(localeLocal, { maximumFractionDigits: 0 })}`;
                        }

                        return (
                          <tr key={`${op.id}-${idx}`}>
                            {modoCombinado && <td className="text-center">{op.paisOrigen}</td>}
                            <td className="text-start">
                              {(() => {
                                const c = clientes[op.client_id];
                                if (!c) return op.cliente || "Cliente desconocido";
                                return c.producto && c.producto !== c.empresa
                                  ? `${c.empresa} | ${c.producto}`
                                  : c.empresa;
                              })()}
                            </td>
                            <td className="text-end">{montoFila}</td>
                            <td className="text-center">
                              <span
                                className="badge"
                                style={{
                                  backgroundColor: op.estatus === "90%" ? "#dc3545" : "#0d6efd",
                                  color: "white",
                                }}
                              >
                                {op.estatus}
                              </span>
                              {op.esContrato && (
                                <span
                                  className="badge ms-1"
                                  style={{ backgroundColor: "#198754", color: "white", fontSize: "0.65rem" }}
                                >
                                  CONTRATO
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    {(() => {
                      let totalImporte = 0;
                      pipelineModal.items.forEach((op) => {
                        const importe = parseFloat(op.importe) || 0;
                        if (showInDollars || modoCombinado) {
                          if (op.moneda_dolar) {
                            totalImporte += importe;
                          } else {
                            const rate = op.paisOrigen === "Chile" ? tipoCambioActual : 3.75;
                            totalImporte += importe / rate;
                          }
                        } else {
                          totalImporte += importe;
                        }
                      });
                      return (
                        <tr style={{ backgroundColor: "rgba(0,0,0,0.85)" }}>
                          <td colSpan={modoCombinado ? 2 : 1} style={{ color: "white", fontWeight: 700 }}>
                            TOTAL
                          </td>
                          <td className="text-end" style={{ color: "white", fontWeight: 700 }}>
                            {showInDollars || modoCombinado
                              ? `US$ ${totalImporte.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`
                              : `${moneda(pais)}${totalImporte.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`}
                          </td>
                          <td className="text-center" style={{ color: "white", fontSize: "1rem" }}>
                            ⚙️ ⚙️
                          </td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
        <div className={styles.modalFooter}>
          <button onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};
